import { Navigate, useParams } from "react-router-dom";
import { useAuth } from "../services/auth-context";

/** Role-based post-login landing: a Manager lands on their dashboard, an Employee lands on their
 * test — this is the element for the bare `/company/:slug` index route, reached right after
 * sign-in (and by the sidebar's "Home" link for a Manager). */
export function SignInRouter() {
  const { slug } = useParams<{ slug: string }>();
  const { auth } = useAuth();

  if (!slug || auth?.role !== "member") return <Navigate to={`/company/${slug}/login`} replace />;
  return <Navigate to={auth.isManager ? `/company/${slug}/dashboard` : `/company/${slug}/test`} replace />;
}
